export interface OpenMenuAction {
    type: 'OPEN_MENU';
}
export const openMenu = (): OpenMenuAction => ({ type: 'OPEN_MENU' });

export interface CloseMenuAction {
    type: 'CLOSE_MENU';
}
export const closeMenu = (): CloseMenuAction => ({ type: 'CLOSE_MENU' });

export interface SetHighlightAction {
    type: 'SET_HIGHLIGHT';
    index: number;
}
export const setHighlight = (index: number): SetHighlightAction => ({
    type: 'SET_HIGHLIGHT',
    index,
});

export interface ClearHighlightAction {
    type: 'CLEAR_HIGHLIGHT';
}
export const clearHighlight = (): ClearHighlightAction => ({ type: 'CLEAR_HIGHLIGHT' });

export type NavigateDirection = 'up' | 'down' | 'first' | 'last';

export interface NavigateAction {
    type: 'NAVIGATE';
    direction: NavigateDirection;
    /** Total number of navigable (non-disabled) items, computed from DOM at dispatch time */
    totalItems: number;
}
export const navigate = (direction: NavigateDirection, totalItems: number): NavigateAction => ({
    type: 'NAVIGATE',
    direction,
    totalItems,
});

export type MenuAction = OpenMenuAction | CloseMenuAction | SetHighlightAction | ClearHighlightAction | NavigateAction;
